import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";
import { constructQueryString } from "../../Util/HelperFunction";

export const workerListAction = createAsyncThunk(
  "worker/list",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`school/worker/list?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const workerDetailAction = createAsyncThunk(
  "worker/detail",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`school/worker/details?id=${reqBody}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const workerCreateAction = createAsyncThunk(
  "worker/create",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post(`school/worker/create`, reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const workerEditAction = createAsyncThunk(
  "worker/edit",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put("school/worker/update", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const multiWorkerCreateAction = createAsyncThunk(
  "worker/multiWorker",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("school/worker/uploadWorkers", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const workerDailyUsageAction = createAsyncThunk(
  "worker/dailyUsage",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `school/worker/active-hours?id=${reqBody.id}&startOfWeek=${reqBody?.date.startOfWeek}&endOfWeek=${reqBody?.date?.endOfWeek}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const workerResetPasswordAction = createAsyncThunk(
  "worker/resetPassword",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("school/worker/reset-password", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  },
);

export const resetWorkerAction = createAction("worker/reset");
